var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"short-container"},[_c('div',{staticClass:"row h-30 w-100"},[_c('div',{staticClass:"tag-container"},_vm._l((_vm.tag),function(t){return _c('span',{key:t.id,class:{
          'badge badge-pill badge-primary': true,
          'badge-active': _vm.activeTag === t,
        },on:{"click":function($event){$event.preventDefault();return _vm.handleChangeTags(t)}}},[_vm._v(_vm._s(t))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }